import { gql } from '@apollo/client';

export const postCreditoDamnificadosBahiaBlanca = gql`
mutation creditoDamnificadosBahiaBlancaRQ{
    creditoDamnificadosBahiaBlancaRS(input: $input)  
        @rest(type: "creditoDamnificadosBahiaBlancaRS", path: "/api/gateway/formularios/bahiablanca", method: "POST"){
            nroSolicitud
            nroSecuencia
            resultado
            error
            stackTrace
        }
}
` 